import { render, staticRenderFns } from "./SedimentResultsMenu.vue?vue&type=template&id=09a0220e&scoped=true"
import script from "./SedimentResultsMenu.vue?vue&type=script&lang=js"
export * from "./SedimentResultsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a0220e",
  null
  
)

export default component.exports